import React from 'react';
import { useCountdown } from '../contexts/CountdownContext';
export function TopBar() {
  const {
    label
  } = useCountdown();
  return <div className="fixed inset-x-0 top-0 z-50 bg-oceano" data-id="element-156" data-mp="231c4810qzhxu">
      <div className="mx-auto flex h-9 max-w-content items-center justify-center gap-3 px-4 sm:h-11" data-id="element-157" data-mp="1y3ajzcrl5cks">
        <p className="font-sans text-[9.5px] font-medium uppercase tracking-[0.16em] text-polar/85 sm:text-[11px] sm:tracking-[0.24em]" data-id="element-158" data-mp="1t5isgjuursh4">
          Oferta especial disponible por
        </p>
        <p className="font-sans text-[12px] font-bold tabular-nums tracking-[0.08em] text-caribe sm:text-sm" aria-live="off" data-id="element-159" data-mp="2lsv4i03e0hw6">
          {label}
        </p>
      </div>
    </div>;
}